export default function filterImageExtensions(filename) {
  let extension = filename.substr(filename.lastIndexOf(".") + 1);
  return extension !== "bmp";
}
